import { Input } from 'shared/ui/input';
import styles from './styles.module.scss';
import { ChangeEvent, FC } from 'react';

type SpecializationsSearchProps = {
  onInput: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const SpecializationsSearch: FC<SpecializationsSearchProps> = ({
  onInput
}) => {

	return (
		<div className={styles['specializations-search']}>
			<div className="mb-4 mt-4">
				<Input placeholder="ФИО врача или специальность" onInput={onInput}/>
			</div>
			{/* <div className="mb-4">
				<PopularSpecializations />
			</div> */}
		</div>
	);
};
